import { Button, ButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { toSxArray } from '@shared/theme/util';

const MiniButton = ({ children, sx, ...props }: ButtonProps) => (
  <Button
    color="inherit"
    variant="outlined"
    size="small"
    {...props}
    sx={[
      (theme) => ({
        fontSize: '0.7rem',
        padding: theme.spacing(0, 1),
        borderRadius: 16,
        fontWeight: 400,
        textTransform: 'unset',
      }),
      ...toSxArray(sx),
    ]}
  >
    {children}
  </Button>
);

export default MiniButton;

export const DiscreetMiniButton = (props: ButtonProps) => (
  <MiniButton color="grey" variant="contained" {...props} />
);

export interface ToggleMiniButtonProps {
  selected?: boolean;
  deselectable?: boolean;
}

export const ToggleMiniButton = styled(MiniButton, {
  shouldForwardProp: (propName) =>
    propName !== 'selected' && propName !== 'deselectable',
})<ToggleMiniButtonProps>(({ theme, selected, deselectable }) => ({
  ...(selected
    ? {
        background: theme.palette.background.inverted,
        color: theme.palette.getContrastText(theme.palette.background.inverted),
        ...(deselectable ? {} : { pointerEvents: 'none' }),
      }
    : {}),
}));
